(function ($) {
  'use strict';

  // Replace input[type=submit] and input[type=reset] with <button> so styles and pseudo-elements apply.
  function replaceSubmitAndResetInputs() {
    var selector = '.view-filters .form-actions input#edit-submit-lista-de-contratos, .view-filters .form-actions input#edit-reset';
    $(selector).each(function () {
      var $input = $(this);
      if (!$input.closest('form').length) return;
      var type = $input.attr('type') === 'reset' ? 'reset' : 'submit';
      var classes = ($input.attr('class') || '').split(/\s+/).filter(Boolean).join(' ');
      var value = $input.val() || $input.attr('value') || (type === 'submit' ? 'Enviar' : 'Reset');

      var $btn = $('<button></button>');
      $btn.attr('type', type);
      // add 'btn' so SCSS rules that target .btn apply
      if (classes) $btn.attr('class', classes + ' form-submit btn');
      else $btn.attr('class', 'form-submit btn');
      if ($input.attr('name')) $btn.attr('name', $input.attr('name'));
      if ($input.attr('id')) $btn.attr('id', $input.attr('id'));

      $btn.text(value);

      $input.replaceWith($btn);
    });
  }

  // Submit/reset buttons use FontAwesome via CSS ::before; do not insert extra <i> elements here.
  function ensureButtonIcons() {
    return;
  }

  $(document).ready(function () {
    replaceSubmitAndResetInputs();
    ensureButtonIcons();
    addViewNodeIcons();

    // Re-run after AJAX refreshes
    $(document).ajaxComplete(function () {
      replaceSubmitAndResetInputs();
      ensureButtonIcons();
      addViewNodeIcons();
    });
  });

  // Add icon to 'Ver Proceso' links inside views-field-view-node
  function addViewNodeIcons() {
    $('.views-field.views-field-view-node .field-content a').each(function () {
      var $a = $(this);
      if ($a.children('i.fas.fa-eye, i.fa.fa-eye').length) return;
      $a.children('i.fas, i.fa').remove();
      $a.prepend('<i class="fas fa-eye" aria-hidden="true"></i> ');
    });
  }
})(jQuery);
